<script lang="ts">
  import { page } from '$app/stores';

  import { createEventDispatcher } from 'svelte';

  import Link from '$components/ui/link.svelte';
  import Select from '$components/ui/select/select.svelte';
  import Skeleton from '$components/ui/skeleton.svelte';

  import { t } from '$lib/i18n';
  import { cn } from '$lib/utils';
  import { aboveLg } from '$lib/stores/breakpoints';
  import type { StoryblokSortKey } from '$lib/stores/content';
  import { getValidNumberBetween } from '$lib/utils/number';

  export let sortkeys: StoryblokSortKey[];
  export let total: number | null;
  export let menuOpen = false;
  export let loading = false;
  export let disabled = false;
  let className: string | undefined = undefined;
  export { className as class };

  const dispatch = createEventDispatcher<{ toggleFilterMenu: undefined }>();
</script>

<div class={cn('flex justify-between items-center lg:px-0 px-2', className)}>
  {#if loading}
    <Skeleton class="rounded-sm h-4 w-30" />
  {:else if total !== null && !loading}
    <p class="text-md/none text-primary/40">{$t('shop.n-products', { value: total.toString() })}</p>
  {/if}
  <div class="justify-self-end ml-auto flex gap-8">
    {#if $aboveLg}
      <Select
        sameWidth={false}
        name="sort"
        variant="link"
        form="filters"
        {disabled}
        value={getValidNumberBetween(
          Number($page.url.searchParams.get('sort')),
          0,
          sortkeys.length
        ).toString()}
        items={sortkeys.map((key, i) => ({ value: i.toString(), label: key.label }))}
      />
    {/if}

    <Link
      type="button"
      as="button"
      rightIcon="filter"
      class="text-md/none"
      on:click={() => dispatch('toggleFilterMenu')}
    >
      {menuOpen && $aboveLg ? $t('shop.hide-filters') : $t('shop.show-filters')}
    </Link>
  </div>
</div>
